import { useEffect, useState, useRef } from "react";
import "./PersonalData.scss";
import { Button, Form, Input, Select, Spin, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { UploadOutlined } from "@ant-design/icons";
import { uploadFile } from "../../services/FileService";
import { RcFile } from "antd/es/upload";
import { updateParticipant } from "../../services/ParticipantService";
import { AxiosResponse } from "axios";
import { Toast } from "primereact/toast";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";

const PersonalData = (props: any) => {
  const [form] = Form.useForm();
  const [photo, setPhoto] = useState();
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const toast = useRef<any>(null);

  useEffect(() => {
    if (props.oneParticipant) {
      form.setFieldsValue(props.oneParticipant);
    }
  }, [props.oneParticipant]);

  const documentType = [
    { label: "Predavač", value: "Predavač" },
    { label: "Učesnik", value: "Učesnik" },
    { label: "Gost", value: "Gost" },
    { label: "VIP", value: "VIP" },
    { label: "Sponzorisan", value: "Sponzorisan" },
  ];

  ////// UPLOAD IMAGE
  const handleUpload = async (file: any) => {
    try {
      const response = await uploadFile(file.file);
      const uploadedPhotoWithBackend = response.data;
      props.uploadImageFunc(uploadedPhotoWithBackend);
      setPhoto(uploadedPhotoWithBackend);

      toast?.current?.show({
        severity: "success",
        detail: "Slika je uspešno uploadovana!",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast?.current?.show({
        severity: "error",
        detail: "Došlo je do greške prilikom uploada slike.",
        life: 3000,
      });
    }
  };

  const beforeUpload = (file: RcFile) => {
    // Provera tipa i veličine fajla pre slanja
    const allowedTypes = ["image/jpeg", "image/png"];
    const isAllowedType = allowedTypes.includes(file.type);
    const isAllowedSize = file.size / 1024 / 1024 < 50; // Maksimalna veličina 5MB

    if (!isAllowedType) {
      toast?.current?.show({
        severity: "error",
        detail: "Dozvoljeni formati slika su JPEG i PNG!",
        life: 3000,
      });
    }

    if (!isAllowedSize) {
      toast?.current?.show({
        severity: "error",
        detail: "Slika ne sme biti veća od 50MB!",
        life: 3000,
      });
    }

    return isAllowedType && isAllowedSize;
  };

  ////// END UPLOAD IMAGE

  //// SAVE
  const handleSaveForm = () => {
    let data = form.getFieldsValue();
    data.id = props.oneParticipant.id;
    data.photo = photo;
    setActiveSpinner(true);

    updateParticipant(props.oneParticipant.id, data).then(
      (res: AxiosResponse) => {
        toast?.current?.show({
          severity: "success",
          detail: "Podaci su uspesno sacuvani!",
          life: 3000,
        });
        setActiveSpinner(false);
      }
    );
  };

  return (
    <div className="personal-data">
      <Spin spinning={activeSpinner}>
        <Toast ref={toast} position={"top-right"} />
        <Form
          form={form}
          name="new-legal-entity-form"
          layout="vertical"
          autoComplete="off"
        >
          <div className="inner-box">
            <Form.Item className="form-box" name={"firstName"} label="Ime:">
              <Input className="input-label" placeholder="Ime" />
            </Form.Item>

            <Form.Item className="form-box" name={"lastName"} label="Prezime:">
              <Input className="input-label" placeholder="Ime" />
            </Form.Item>

            <Form.Item name={"type"} label="Tip učesnika:">
              <Select placeholder="Tip učesnika" options={documentType} />
            </Form.Item>
            <Form.Item
              className="form-box"
              name={"phone"}
              label="Kontakt telefon:"
            >
              <Input
                type="text"
                className="input-label"
                placeholder="Unesite kontakt telefon"
              />
            </Form.Item>
            <Form.Item className="form-box" name={"email"} label="E-mail:">
              <Input
                className="input-label"
                placeholder="Unesite e-mail adresu"
              />
            </Form.Item>
            <Form.Item className="form-box" name={"personalId"} label="JMBG:">
              <Input
                type="number"
                className="input-label"
                placeholder="Unesite JMBG"
              />
            </Form.Item>
            <Form.Item
              className="form-box"
              name={"nationalId"}
              label="Broj lične karte / pasoša:"
            >
              <Input
                type="number"
                className="input-label"
                placeholder="Unesite broj lične karte / pasoša"
              />
            </Form.Item>
            <Form.Item className="form-box" name={"country"} label="Drzava:">
              <Input className="input-label" placeholder="Unesite drzavu" />
            </Form.Item>
            <Form.Item className="form-box" name={"city"} label="Grad:">
              <Input className="input-label" placeholder="Unesite grad" />
            </Form.Item>
            <Form.Item className="form-box" name={"street"} label="Ulica:">
              <Input className="input-label" placeholder="Unesite ulicu" />
            </Form.Item>
            <Form.Item
              className="form-box"
              name={"streetNumber"}
              label="Broj ulice:"
            >
              <Input className="input-label" placeholder="Unesite broj ulice" />
            </Form.Item>

            {/* <Form.Item
            className="form-box"
            name={"osiguravajuceDrustvo"}
            label="Osiguravajuće društvo:"
          >
            <Input
              className="input-label"
              placeholder="Unesite osiguravajuće društvo"
            />
          </Form.Item> */}
            {props?.oneParticipant?.type === "Predavač" && (
              <>
                <div>
                  <Form.Item label="Dodaj sliku:">
                    <div className="images-for-roomType">
                      <Upload
                        multiple
                        beforeUpload={beforeUpload}
                        accept="image/*"
                        customRequest={(file) => {
                          handleUpload(file);
                        }}
                        action=""
                        listType="picture"
                        className="upload"
                        showUploadList={false}
                      >
                        <Button
                          className="button-upload"
                          icon={<UploadOutlined />}
                        >
                          Click to Upload
                        </Button>
                      </Upload>
                    </div>
                  </Form.Item>
                </div>
                <Form.Item
                  className="form-box"
                  name={"biography"}
                  label="Biografija predavača:"
                  style={{ gridColumn: "span 3" }}
                >
                  <TextArea
                    className="input-label"
                    placeholder="Unesite biografiju predavača:"
                  />
                </Form.Item>
              </>
            )}
          </div>
          {props?.oneParticipant?.active && (
            <div
              className="sabe-btn-p"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <CustomButton
                danger={true}
                htmlType={"submit"}
                type={"primary"}
                function={() => {
                  handleSaveForm();
                }}
                text={"Izmena podataka"}
              />
            </div>
          )}
        </Form>
      </Spin>
    </div>
  );
};

export default PersonalData;
